.MapContainer {
  width: 100%;
  height: 100%;
  border-radius: 30px;
  position: relative;
  overflow: hidden;
}

.CardDetail {
  display: flex;
  position: relative;
  width: 650px;
  height: 100%;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  border-radius: 30px;
  background: var(--colori-neutri-background);
  margin-left: 8px;
}

.ContainerButtons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 1;
}

.ButtonMyLocation {
  display: flex;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  transition: all 0.3s ease-in-out;
}

.MarkerCluster{
  display: flex; 
}

.TitleMarkerCluster{
  color: var(--primary);
  overflow: hidden;
  text-overflow: ellipsis;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: max-content;
  margin-left: 10px;
  text-decoration: none;
}

.SwitchContainerCluster {
  padding: 4px;
  background-color: var(--colori-neutri-white);
  border-radius: 10px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--primary);
}

.LabelSwitch{
  margin-right: 8px;
}

.ButtonMyLocation:hover,
.ButtonMyLocation:active {
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.1) 0%,
      rgba(0, 0, 0, 0.1) 100%
    ),
    #fff;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}

.ButtonLegend {
  display: flex;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  cursor: pointer;
}

.ButtonLegend:hover,
.ButtonLegend:active {
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.1) 0%,
      rgba(0, 0, 0, 0.1) 100%
    ),
    #fff;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}

.ButtonMappe {
  display: flex;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  margin-bottom: 8px;
  border: none;
}

.DetailMarker {
  display: flex;
  width: 160px;
  height: max-content;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  /* Markers */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.DetailMarkerCluster{
  
  width: 160px;
  height: max-content;
  padding: 8px;
  
  border-radius: 5px;
  /* Markers */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.PinMarker {
  position: absolute;
  bottom: -10px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  content: ' ';
  font-size: 0;
  line-height: 0;
  margin-left: -10px;
  width: 0;
}

.TitleMarker {
  color: var(--colori-neutri-white);
  text-align: center;
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.TextMarker {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--colori-neutri-white, #fff);
  text-align: center;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.LegendButton {
  border-radius: 30px;
  background: var(--primary);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  margin-top: 8px;
  transition: all 0.3s ease-in-out;
}

.ZoomIn {
  border-radius: 30px !important;
  background: var(--colori-neutri-white) !important;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 44px !important;
  height: 44px !important;
  border: none !important;
  margin-top: 8px !important;
  position: absolute !important;
  right: 24px !important;
  top: 16px !important;
  font-size: 30px !important;
  color: var(--primary) !important;
  font-weight: normal !important;
  cursor: pointer !important;
}

.ZoomOut {
  border-radius: 30px !important;
  background: var(--colori-neutri-white) !important;
  font-weight: normal !important;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 44px !important;
  height: 44px !important;
  border: none !important;
  margin-top: 8px !important;
  position: absolute !important;
  right: 24px !important;
  top: 64px !important;
  font-size: 30px !important;
  color: var(--primary) !important;
  transition: all 0.3s ease-in-out !important;
  cursor: pointer !important;
}

.ButtonResetItalia {
  border-radius: 30px !important;
  background: var(--colori-neutri-white) !important;
  font-weight: normal !important;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 44px !important;
  height: 44px !important;
  border: none !important;
  margin-top: 8px !important;
  position: absolute !important;
  right: 16px !important;
  top: 120px !important;
  font-size: 30px !important;
  color: var(--primary) !important;
  transition: all 0.3s ease-in-out !important;
  cursor: pointer !important;
  z-index: 1;
}

.ZoomIn:hover,
.ZoomOut:hover,
.ButtonResetItalia:hover {
  background: rgb(208, 223, 228) !important;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25) !important;
  border: transparent !important;
  outline: none !important;
}

.LegendButton:hover {
  background: rgba(17, 138, 178, 0.8);
  cursor: pointer;
}

.LegendButtonActive {
  border-radius: 30px;
  border: 3px solid var(--secondary);
  background: var(--primary);
  box-shadow: 0px 0px 10px 0px #bdecff;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 30px;
  margin-top: 8px;
}

.LoadingButton {
  display: flex;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  margin-bottom: 8px;
  border: none;
  position: absolute;
  left: 24px;
  top: 90px;
  z-index: 1;
}

.ContainerLegendAndSwitch{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 24px;
  top: 24px;
  z-index: 1;
}

.SwitchMapList {
  height: 45px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 30px;
  background: var(--primary);
  width: 175px;
  margin-right: 8px;
  margin-left: 8px;
}

.SwitchItemActive {
  border-radius: 100px;
  background: var(--colori-neutri-white);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  color: var(--primary);
  padding: 8px 4px;
  cursor: pointer;
  width: 50%;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-right: 4px;
}

.SwitchItem {
  color: var(--colori-neutri-gray-2);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  padding: 8px 4px;
  cursor: pointer;
  width: 50%;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.SwitchItem:hover {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 100px;
}

.FiltersColumn {
  height: 100%;
  flex: 0 0 auto;
  overflow: hidden;
}

.ResizeHandle {
  width: 8px;
  min-width: 8px;
  height: 100%;
  cursor: col-resize;
  position: relative;
  flex: 0 0 auto;
}

.ResizeHandle::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  /* background: rgba(0, 0, 0, 0.08); */
  transition: background 0.2s ease;
}
